<template>
  <MaskLayer
    v-if="showForm"
    class="position-absolute"
    style="max-height: 100%"
  >
    <!-- 獎品名稱 begin -->
    <div
      class="bg-white d-flex flex-column pt-3 rounded-md text-center position-relative"
      style="width: 90%; max-width: 560px; max-height: 95vh"
    >
      <PerfectScrollbar class="text-center px-3 px-md-4 flex-grow-1">
        <!-- 標題文字/標題圖片 begin -->
        <div
          class="w-100"
          :class="{ 'text-left': !isReceivingFormComplete }"
        >
          <template v-if="!isReceivingFormComplete">
            <h3 class="mb-0">
              {{ $t("global.award-information") }}
            </h3>
            <p class="mb-3">
              {{ $t("global.award-information-desc") }}
            </p>
            <Name
              v-if="AwardInformation.isName"
              ref="name"
              :answer.sync="name"
              :required="true"
            />
            <PhoneNumber
              v-if="AwardInformation.isMobile"
              ref="mobile"
              :answer.sync="mobile"
              :required="true"
            />
            <EMail
              v-if="AwardInformation.isEmail"
              ref="email"
              :answer.sync="email"
              :required="true"
            />
            <SimpleAns
              v-if="AwardInformation.isAddress"
              ref="address"
              :answer.sync="address"
              :required="true"
            />
            <PersonalID
              v-if="AwardInformation.isIdentityNumber"
              ref="identityNumber"
              :answer.sync="identityNumber"
              :required="true"
            />
          </template>
          <template v-else>
            <h6 class="mb-3">
              {{ $t("activity.congratuation-on-getting") }}
            </h6>
            <h3 class="mb-0">
              {{ prizeTitle }}
            </h3>
            <div class="m-auto image-panel image-panel-5 bg-none my-2">
              <img :src="prizeImage">
            </div>
            <div class="font-size-md text-gray600">
              {{ $t("global.form-completed") }}
            </div>
          </template>
        </div>
        <!-- 標題文字/標題圖片 end -->
      </PerfectScrollbar>
      <div class="p-3">
        <b-button
          class="w-100"
          :style="{
            background: `rgba(${entertainmentInfo().resultColor}, 0.75)`,
            'border-color': `rgba(${entertainmentInfo().resultColor}, 1.0)`,
            color: `rgba(${
              entertainmentInfo().resultColor === '255,255,255'
                ? '45,167,193'
                : '255,255,255'
            },1.0)`,
          }"
          @click="confirm"
        >
          {{ $t("global.confirm") }}
        </b-button><!-- 色碼同行動呼籲按鈕, 形狀：pill/空值/squared (使用在會員中心前台，不要style，class加 bg-customize border-customize) -->
      </div>
    </div>
    <!-- 獎品名稱 end -->
  </MaskLayer>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import MaskLayer from '@/components/MaskLayer.vue';
import PerfectScrollbar from '@/components/PerfectScrollbar.vue';
import Name from '@/components/model/Name.vue';
import PhoneNumber from '@/components/model/PhoneNumber.vue';
import EMail from '@/components/model/EMail.vue';
import SimpleAns from '@/components/model/SimpleAns.vue';
import PersonalID from '@/components/model/PersonalID.vue';

export default {
  components: {
    MaskLayer,
    PerfectScrollbar,
    Name,
    PhoneNumber,
    EMail,
    SimpleAns,
    PersonalID,
  },
  data() {
    return {
      name: '',
      mobile: '',
      email: '',
      address: '',
      identityNumber: '',
    };
  },
  computed: {
    ...mapGetters(['entertainmentInfo']),
    ...mapState([
      'showForm',
      'isReceivingFormComplete',
      'AwardInformation',
      'prizeTitle',
      'prizeImage',
    ]),
  },
  methods: {
    ...mapActions(['patchCommunicationData']),
    ...mapMutations(['set']),
    confirm() {
      const body = {};
      if (this.AwardInformation.isName) {
        body.name = this.name;
      }
      if (this.AwardInformation.isMobile) {
        body.mobile = this.mobile;
      }
      if (this.AwardInformation.isEmail) {
        body.email = this.email;
      }
      if (this.AwardInformation.isAddress) {
        body.address = this.address;
      }
      if (this.AwardInformation.isIdentityNumber) {
        body.identityNumber = this.identityNumber;
      }

      if (!this.isReceivingFormComplete) {
        if (this.checkData()) {
          this.patchCommunicationData(body);
          this.set({ name: 'isReceivingFormComplete', value: true });

          this.$notify.create({
            title: this.$t('global.fill-completed'), // 標題
            dismissCountDown: 1, // 顯示多久後隱藏 (sec)
            type: 'success', // 類型 (success|danger|warning|info|light|dark)
          });

          this.set({
            name: 'showForm',
            value: false,
          });
        }
      } else {
        this.set({
          name: 'showForm',
          value: false,
        });
      }
    },
    checkData() {
      const validates = [];
      if (this.AwardInformation.isName) {
        validates.push(this.$refs.name.validate());
      }
      if (this.AwardInformation.isMobile) {
        validates.push(this.$refs.mobile.validate());
      }
      if (this.AwardInformation.isEmail) {
        validates.push(this.$refs.email.validate());
      }
      if (this.AwardInformation.isAddress) {
        validates.push(this.$refs.address.validate());
      }
      if (this.AwardInformation.isIdentityNumber) {
        validates.push(this.$refs.identityNumber.validate());
      }

      if (validates.indexOf(false) > -1) {
        return false;
      }

      return true;
    },
  },
};
</script>
